/** Security page: account summary, active sessions, change password. */
export const security = {
  title: "Security",
  eyebrow: "Settings",
  intro: "Your sign-in, password and active sessions.",
  name: "Name",
  email: "Email",
  role: "Role",
  organization: "Organization",
  twoStep: "Two-step verification",
  on: "On",

  // Sessions (OS and browser names are product names and stay as they are)
  unknownDevice: "Unknown device",
  unknownOs: "Unknown OS",
  browser: "Browser",
  browserOnOs: "{browser} on {os}",
  sessionsTitle: "Active sessions",
  sessionsSub: "Devices logged in to your account. End any session you don't recognise, then change your password.",
  thisDevice: "This device",
  unknownIpTitle: "Unknown IP",
  sessionMeta: "<code>{ip}</code> · Active {ago} · Signed in {at}",
  endSession: "End session",
  endTitle: "End this session?",
  endDesc: "{device} ({ip}) will be logged out.",
  unknownIp: "unknown IP",
  sessionEnded: "Session ended",

  // Change password
  pwTooShort: "Use at least 12 characters.",
  pwTooLong: "Use at most 128 characters.",
  pwMismatch: "Passwords don't match.",
  curRequired: "Enter your current password.",
  pwLength: "Your new password needs 12 to 128 characters.",
  newMismatch: "New passwords don't match.",
  codeRequired: "Enter the 6-digit code from your authenticator app.",
  codeFailed: "That code didn't work. Wait for the next code and try again.",
  pwChanged: "Password changed",
  pwTitle: "Change password",
  pwSub: "This logs out all your other sessions.",
  curPw: "Current password",
  newPw: "New password",
  pwHint: "12 to 128 characters.",
  confirmPw: "Confirm new password",
  pwChangedBody: "Password changed. Your other sessions were logged out.",
  changePw: "Change password",
};
